import { AppShell } from "@/components/shell/AppShell";
import { Outlet } from "react-router-dom";

export function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
